import React, { FC } from 'react';
import { TbBell, TbBellOff, TbBellX } from 'react-icons/tb';

import { Box, Tooltip } from '@mantine/core';

import { Project, Team } from 'models';
import { TeamHelpers } from 'helpers/TeamHelpers';

import { SimpleButton } from 'components/buttons/SimpleButton';
import { useCurrentUser } from 'hooks/use-current-user';
import { useProjectFollow } from 'hooks/use-project-follow';

const ProjectTeaserFollow: FC<{ projectId: Project['id']; team: Team | null; isVisible: boolean }> = ({
    projectId,
    team,
    isVisible,
}) => {
    const user = useCurrentUser();
    const isTeamMember = TeamHelpers.isPartOfTeam(team, user);

    const { following, toggle, toggling, isLoading } = useProjectFollow(isVisible && isTeamMember ? projectId : null);

    if (!isVisible || !team) {
        return null;
    }

    if (!isTeamMember) {
        return (
            <Tooltip
                label="You can't follow or unfollow this project as a collaborator. You still get notified about the chats you're in and when someone mentions you."
                multiline
                w={260}
                withArrow
            >
                <Box onClick={(event) => event.preventDefault()}>
                    <SimpleButton disabled aria-label="Following not available">
                        <TbBellX />
                    </SimpleButton>
                </Box>
            </Tooltip>
        );
    }

    if (isLoading) {
        return null;
    }

    return (
        <Tooltip label={following ? 'Following. Click to unfollow.' : 'Not following. Click to follow.'} withArrow>
            <SimpleButton
                loading={toggling}
                onClick={(event) => {
                    event.preventDefault();
                    toggle().then();
                }}
                aria-label={following ? 'Unfollow project' : 'Follow project'}
            >
                {following ? <TbBell color="var(--mantine-color-green-6)" /> : <TbBellOff />}
            </SimpleButton>
        </Tooltip>
    );
};

export { ProjectTeaserFollow };
